
<!-- The routed views render in the <router-outlet>-->
<router-outlet></router-outlet>

